export default "__VITE_ASSET__DWPE3fB2__"